/* delete this file when com.atlassian.rm.jpo.jpo3cloud.centralise-react-virtualized-overflow-styles
is cleaned up. It has moved to app-simple-plans/styles.module.css */

/* HACK overflow: visible prevents @atlaskit/layer dependent components from clipping */
/* will-change: auto prevents breakage of stacking contexts caused by original will-change: transform */
#jira-frontend .ReactVirtualized__Grid,
#jira-frontend .ReactVirtualized__List {
	overflow: visible !important;
	will-change: auto !important;
}

#jira-frontend .ReactVirtualized__Grid__innerScrollContainer {
	overflow: visible !important;
}
/* /HACK */
